export default {"src":"/_next/static/media/urbania.49c99cbf.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};